import { render, staticRenderFns } from "./iybr-form-submit-confirmation.vue?vue&type=template&id=3238a870"
import script from "./iybr-form-submit-confirmation.ts?vue&type=script&lang=ts&external"
export * from "./iybr-form-submit-confirmation.ts?vue&type=script&lang=ts&external"
import style0 from "./iybr-form-submit-confirmation.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3238a870')) {
      api.createRecord('3238a870', component.options)
    } else {
      api.reload('3238a870', component.options)
    }
    module.hot.accept("./iybr-form-submit-confirmation.vue?vue&type=template&id=3238a870", function () {
      api.rerender('3238a870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-form-submit-confirmation/iybr-form-submit-confirmation.vue"
export default component.exports